
import Advertisement from "@/components/Advertisement";
import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import CheckBox from "@/components/main/core/CheckBox";
import BlogPost from "@/components/main/blog/BlogPost";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import RedSearchNow from "@/components/main/core/RedSearchNow";

import 'epic-spinners/dist/lib/epic-spinners.min.css'
import {BreedingRhombusSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js'
import Paginate from 'vuejs-paginate/src/components/Paginate.vue';
const StarRating = process.client ? require('vue-star-rating').default : undefined
import CtaSteps from "@/components/main/steps/CtaSteps";

export default {

  head() {
    const title = this.titleForBlogTags(this.upperCaseTitle);
    const description = this.currentTag ? this.currentTag.seo_description : '';
    const ogTitle = `${this.currentTag ? this.currentTag.seo_title : '' } ᐈ Read in blog iFindCheaters`;

    return {

      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.metaKeywordsForBlogTags(this.upperCaseTitle)
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: ogTitle
        }
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `https://ifindcheaters.com/blog/tag/${this.$route.params.slug}/`,
        },
      ],
    }
  },

  name: "slug",
  layout: 'clientLayout',
  mixins: [],
  components: {Advertisement, ClientHead, RedSection, CheckBox, BlogPost, RedHeadBox, RedSearchNow, BreedingRhombusSpinner, Paginate, StarRating, CtaSteps},
  data() {
    return {
      tagPostsData: null,
      popularPostsData: null,
      tagsData: null,
      categoriesData: null,
      showMore: false,
    }
  },
  computed: {
    upperCaseTitle() {
      return this.$route.params.slug.split('-').map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join(' ');
    },
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page) : 1
    },
    currentCategory() {
      return this.tagsData?.data?.find(tag => tag.slug === this.$route.params.slug);
    },
  },

  async fetch() {
    const page = this.$route.query.page || 1;
    try {
      const [tagPostsResponse, popularPostsResponse, tagsResponse, categoriesResponse] = await Promise.all([
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/tag/${this.$route.params.slug}/?page=${page}`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/popular`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/tags`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/categories`),
      ]);

      this.tagPostsData = tagPostsResponse.data;
      this.popularPostsData = popularPostsResponse.data;
      this.tagsData = tagsResponse.data;
      this.categoriesData = categoriesResponse.data;
    } catch (error) {
      console.error('Error:', error);
    }
  },

  methods: {
    pageChange(page) {
      let self = this
      this.$axios
        .get(`${process.env.BLOG_API_BASE_URL}/api/tag/${this.$route.params.slug}/?page=${page}`)
        .then(response => {
          self.tagPostsData = response.data
          self.$router.push(page === 1 ? `/blog/tag/${self.$route.params.slug}/` : `/blog/tag/${self.$route.params.slug}/?page=${page}`);
        })
        .catch(function (error) {
          console.log('error: ' + error);
        });
    },
    //This is the solution for adding meta keywords because we can't add meta keywords in our wordpress admin.
    metaKeywordsForBlogTags(blogTag) {
      switch (blogTag) {
        case 'How To Search Someone On Tinder':
          return 'how to find out if someones on tinder, how to find people on tinder, find someone on tinder, find people tinder';
        default:
          return '';
      }
    },
    //This is the solution for adding meta description only for one search result
    metaDescriptionForBlogTags(blogTag) {
      switch (blogTag) {
        case 'How To Search Someone On Tinder':
          return `Read online articles on the topic - ${this.tagPostsData ? this.upperCaseTitle : '' }, Best Way to find people on tinder & How to find out if someone is on tinder.`;
        default:
          return `Read online Articles on the topic【${this.tagPostsData ? this.upperCaseTitle : '' }】in Blog ⏩ iFindCheaters ❤️ Find your cheating Spouse and Partner ⚡ Husband or Wife ⭐️ Anonymously ⚡ By email and name!`;
      }
    },
    //This is the solution for adding title only for one search result
    titleForBlogTags(blogTag) {
      switch (blogTag) {
        case 'How To Search Someone On Tinder':
          return `${this.tagPostsData ? this.upperCaseTitle  : ''} - Comprehensive Guide | iFindCheaters`;
        default:
          return `${this.tagPostsData ? this.upperCaseTitle  : ''} ᐈ Read in blog iFindCheaters`;
      }
    },
    paginatePage(pageNum) {
      this.pageChange(pageNum)
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
  }
}
